'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUngatedForUTV = undefined;

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getGates = require('../../selectors/widgetDataSelectors/getGates');

var _gatesConstants = require('../constants/gatesConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isUngatedForUTV = exports.isUngatedForUTV = (0, _reselect.createSelector)([_getGates.getGates], function (gates) {
  return Boolean((0, _get2.default)(_gatesConstants.LIVECHAT_UTV, gates));
});